var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "accordion", class: _vm.accordionClass },
      [
        _vm.headinglink
          ? _c(
              "div",
              {
                staticClass: "accordion__header header__menu-main-link",
                class: _vm.headerClass,
                attrs: { "aria-label": _vm.heading },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.activate($event)
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "accordion__title",
                    attrs: { href: _vm.headinglink }
                  },
                  [_vm._v(_vm._s(_vm.heading))]
                ),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.active,
                        expression: "active"
                      }
                    ],
                    staticClass: "accordion__action",
                    on: {
                      click: function($event) {
                        return _vm.onActionClicked()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.action))]
                ),
                _c("icon", {
                  class: _vm.iconClass,
                  attrs: { name: _vm.currentIcon, size: "22px" }
                })
              ],
              1
            )
          : _c(
              "div",
              {
                staticClass: "accordion__header header__menu-main-link",
                class: _vm.headerClass,
                attrs: { "aria-label": _vm.heading },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.activate($event)
                  }
                }
              },
              [
                _c("span", { staticClass: "accordion__title" }, [
                  _vm._v(_vm._s(_vm.heading))
                ]),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.active,
                        expression: "active"
                      }
                    ],
                    staticClass: "accordion__action",
                    on: {
                      click: function($event) {
                        return _vm.onActionClicked()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.action))]
                ),
                _c("icon", {
                  class: _vm.iconClass,
                  attrs: { name: _vm.currentIcon, size: "22px" }
                })
              ],
              1
            ),
        _c("transition", { attrs: { name: _vm.transition } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active,
                  expression: "active"
                }
              ],
              ref: "content",
              staticClass: "accordion__content",
              style: _vm.contentStyle
            },
            [_vm._t("default")],
            2
          )
        ])
      ],
      1
    ),
    _c("hr", { staticClass: "mobile-menu-main-link-button-line" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }